module.exports = __webpack_public_path__ + "img/Flag_France.9d18c477.svg";